// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cemu","type":"styles_type__2P45I","choices":"styles_choices__1G2kJ"};